import PropTypes from "prop-types";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
// Importiamo Slider e Typography da Material UI
import { Link, Slider, Typography, Box } from "@mui/material";
import ProductgridList from "./ProductgridList";
import HTMLFlipBook from "react-pageflip";
import ProductMobile from "../../pages/shop-product/ProductMobile";
import ProductPageCatalog from "../../pages/shop-product/ProductPageCatalog";
import ProductPageCatalogTemplate from "../../pages/shop-product/ProductPageCatalogTemplate";
import { template } from "lodash";

const ShopProductsFlip = (props) => {
  const {
    products,
    layout,
    isLoggedUser,
    visualizzaPrezzi,
    oneProduct,
    catalogo,
  } = props;

  // 1. CORRETTO: Usa useRef invece di createRef
  const flipBook = useRef(null);

  const [currentPage, setCurrentPage] = useState(0);
  const [totPages, setTotPages] = useState(0); // Inizializzato a 0


  // Stato per gestire il dialog di modifica quantità
  const [editDialog, setEditDialog] = useState({
    isOpen: false,
    id: null,
    currentQty: 0,
    min: 0,
    conf: 1
  });

  // Gestione cambio pagina dal FlipBook (evento onFlip)
  const onFlip = useCallback((e) => {
    setCurrentPage(e.data);
    // Aggiorniamo il totale delle pagine dinamicamente se disponibile
    if (flipBook.current && flipBook.current.pageFlip()) {
      const count = flipBook.current.pageFlip().getPageCount();
      // Sottraiamo 1 perché l'indice parte da 0, oppure teniamo count puro per la UI
      setTotPages(count > 0 ? count - 1 : 0);
    }
  }, []);

  // 2. GESTIONE TASTIERA (Arrow Left / Arrow Right)
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Se il flipbook non è ancora montato, non fare nulla
      if (!flipBook.current || !flipBook.current.pageFlip()) return;

      if (event.key === "ArrowRight") {
        flipBook.current.pageFlip().flipNext();
      } else if (event.key === "ArrowLeft") {
        flipBook.current.pageFlip().flipPrev();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup listener
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Esegue solo al mount
  useEffect(() => {
    if (flipBook.current && flipBook.current.pageFlip()) {
      const count = flipBook.current.pageFlip().getPageCount();
      // Sottraiamo 1 perché l'indice parte da 0, oppure teniamo count puro per la UI
      setTotPages(count > 0 ? count - 1 : 0);
    }
  }, [catalogo]);
  // 3. GESTIONE SLIDER
  const handleSliderChange = (event, newValue) => {
    if (flipBook.current && flipBook.current.pageFlip()) {
      // Flip alla pagina specifica selezionata dallo slider
      flipBook.current.pageFlip().flip(newValue);
    }
  };

  const getNumOfVariants = (product, template) => {
    if (!product || !product.variation) return 0;

    // --- LOGICA SPECIFICA PER GRID_WITH_SIZE ---
    if (template === "grid_with_sizes") {
      const groupedVariants = product.variation.map((v, indexColor) => {
        return {
          colorId: `c-${indexColor}`,
          color: v.color || `Variante ${indexColor + 1}`,
          sizes: (v.size && v.size.length > 0) ? v.size.map((sizeItem, indexSize) => {
            return {
              id: `${indexColor}-${indexSize}`,
              sizeLabel: sizeItem.name || sizeItem.label || "Unica",
              quantity: 0,
              price: sizeItem["pricesco"] || sizeItem.pricesco || "0.00",
              src: global.baseUrlImage + sizeItem.nomImg + "?t=" + Math.random(),
              nomImg: sizeItem.skuSizeColor,
            };
          }) : []
        };
      });
      return groupedVariants.length;
    }

    const initialVariants = product?.variation?.flatMap((v, indexColor) => {
      if (!v || !v.size || v.size.length === 0) return [];
      return v.size.map((sizeItem, indexSize) => {
        return {
          id: `${indexColor}-${indexSize}`,
          color: v.colore || `Variante ${indexColor + 1}`,
          quantity: 0,
          price: sizeItem["pricesco"] || sizeItem.pricesco || "0.00",
          src: global.baseUrlImage + sizeItem.nomImg + "?t=" + Math.random(),
          nomImg: sizeItem.skuSizeColor,
        };
      });
    });
    return initialVariants.length;
  };
  const handleDialogSave = () => {
    setEditDialog({ ...editDialog, isOpen: false });
  }
  return (
    <div
      className="shop-bottom-area mt-12"
      id="products-area"
      style={
        oneProduct
          ? {}
          : global.aziendaID == 4
            ? {
              overflowY: "scroll",
              maxWidth: "85vw",
              overflowX: "hidden",
              scrollbarWidth: "none",
            }
            : {
              overflowY: "scroll",
              maxHeight: "800px",
              maxWidth: "85vw",
              overflowX: "hidden",
              scrollbarWidth: "none",
            }
      }
    >
      {/* --- MODALE EDIT QUANTITÀ --- */}
      {editDialog.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)", // Sfondo scuro semitrasparente
            zIndex: 9999, // Altissimo per stare sopra al libro
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          // Chiude se clicchi fuori (opzionale)
          onClick={() => setEditDialog({ ...editDialog, isOpen: false })}
        >
          <div
            onClick={(e) => e.stopPropagation()} // Evita chiusura se clicchi dentro il box
            style={{
              backgroundColor: "white",
              padding: "2rem",
              borderRadius: "12px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              minWidth: "300px",
              textAlign: "center"
            }}
          >
            <h4>Modifica Quantità</h4>

            {/* Input Reale e Funzionante */}
            <input
              type="number"
              autoFocus // Il focus va subito qui
              value={editDialog.currentQty}
              onChange={(e) =>
                setEditDialog({ ...editDialog, currentQty: e.target.value })
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleDialogSave();
              }}
              style={{
                fontSize: "2rem",
                padding: "10px",
                textAlign: "center",
                border: "2px solid #ddd",
                borderRadius: "8px",
                width: "100%"
              }}
            />

            <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "10px" }}>
              <button
                onClick={() => setEditDialog({ ...editDialog, isOpen: false })}
                className="btn btn-secondary"
                style={{ padding: "10px 20px", border: "1px solid #ccc", background: "#f0f0f0", borderRadius: "5px" }}
              >
                Annulla
              </button>

              <button
                onClick={handleDialogSave}
                className="btn btn-primary"
                style={{ padding: "10px 20px", background: "#007bff", color: "white", border: "none", borderRadius: "5px" }}
              >
                Conferma
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Cambiato in column per accomodare lo slider sotto
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
          {currentPage > 0 && (
            <div className="shopping-cart-btn btn-hover text-center" style={{ marginRight: '10px' }}>
              <Link
                className="default-btn"
                component="button" // Meglio usare component="button" per evitare refresh
                onClick={() => flipBook.current.pageFlip().flip(0)}
                underline="none"
                style={{ height: "65vh", alignContent: "center" }}

              >
                &lt;&lt;
              </Link>
            </div>
          )}
          {/* Bottone Indietro */}
          {currentPage > 0 && (
            <div className="shopping-cart-btn btn-hover text-center" style={{ marginRight: '10px' }}>
              <Link
                className="default-btn"
                component="button" // Meglio usare component="button" per evitare refresh
                onClick={() => flipBook.current.pageFlip().flipPrev()}
                underline="none"
                style={{ height: "65vh", alignContent: "center" }}

              >
                &lt;
              </Link>
            </div>
          )}

          {/* FLIPBOOK */}
          <HTMLFlipBook
            size="fixed"
            width={600}
            height={800}
            minWidth={315}
            maxWidth={1000}
            minHeight={600}
            maxHeight={1000}
            maxShadowOpacity={1}
            showCover={false}
            mobileScrollSupport={true}
            className="demo-book"
            onFlip={onFlip}
            ref={flipBook}
          >
            {(catalogo || []).flatMap((pagina, outerIndex) => {
              // --- LOGICA DI SKIP ---
              if (
                (pagina.template === "grid" || pagina.template === "grid_with_sizes") &&
                (!pagina.IDArtBas || pagina.IDArtBas === 0)
              ) {
                return [];
              }
              if (pagina.template === "end") {
                return Array.from({ length: 1 }).map((_, innerIndex) => (
                  <div
                    key="static-last-page"
                    className="demoPage"
                    style={{
                      backgroundColor: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "20px",
                      minHeight: "65vh"
                    }}
                  >
                    <div style={{ textAlign: "center", height: "100%", justifyContent: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <img src={global.placeholderImage} alt="Logo" style={{ maxWidth: '200px', marginBottom: '20px' }} />
                      <h2>Fine del Catalogo</h2>
                      <p className="mb-4">Scopri la nostra collezione tessile</p>
                      <div className="shopping-cart-btn btn-hover text-center">
                        <a
                          href="/shop-grid-full-width/show=GRAFICHE"
                          className="default-btn"
                          style={{ display: 'inline-block' }}
                        >
                          Vai al Tessile
                        </a>
                      </div>
                    </div>
                  </div>
                ));
              }

              const product = products.find((p) => p.id === pagina.IDArtBas);
              const loopCount = pagina.numPagine && pagina.numPagine > 1 && (pagina.template === "grid" || pagina.template === "grid_with_sizes") ? pagina.numPagine : 1;

              return Array.from({ length: loopCount }).map((_, innerIndex) => {
                const numVariants = getNumOfVariants(product, pagina.template);
                const offsetPerPage =
                  pagina.numPagine && pagina.numPagine > 1
                    ? Math.ceil(numVariants / pagina.numPagine)
                    : numVariants;
                const offset = innerIndex * offsetPerPage;
                const uniqueKey = `page-${outerIndex}-${innerIndex}`;

                return (
                  <div
                    key={uniqueKey}
                    className="demoPage"
                    style={{ backgroundColor: "#fff", padding: "20px" }}
                  >
                    {product && (
                      <ProductPageCatalogTemplate
                        key={`${pagina.IDArtBas}-${innerIndex}`}
                        isLoggedUser={isLoggedUser}
                        visualizzaPrezzi={visualizzaPrezzi}
                        pagina={{ ...pagina, ord: pagina.ord + innerIndex }}
                        product={product}
                        notShowGridAvailability={true}
                        showCatalogo={true}
                        catalogoTemplate={true}
                        offsetPerPage={offsetPerPage}
                        variantOffset={offset}
                        setEditDialog={setEditDialog}
                        editDialog={editDialog}
                      />
                    )}
                  </div>
                );
              });
            })}
          </HTMLFlipBook>

          {/* Bottone Avanti */}
          {currentPage < totPages && (
            <div className="shopping-cart-btn btn-hover text-center" style={{ marginLeft: '10px' }}>
              <Link
                className="default-btn"
                component="button"
                onClick={() => flipBook.current.pageFlip().flipNext()}
                underline="none"
                style={{ height: "65vh", alignContent: "center" }}
              >
                &gt;
              </Link>
            </div>
          )}
          {currentPage < totPages && (
            <div className="shopping-cart-btn btn-hover text-center" style={{ marginLeft: '10px' }}>
              <Link
                className="default-btn"
                component="button"
                onClick={() => flipBook.current.pageFlip().flip(totPages - 1)}
                underline="none"
                style={{ height: "65vh", alignContent: "center" }}
              >
                &gt;&gt;
              </Link>
            </div>
          )}
        </div>

        {/* --- CONTROLLI SLIDER E PAGINAZIONE --- */}
        <Box sx={{ width: 300, mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="caption" display="block" gutterBottom>
            Pagina {currentPage + 1} di {totPages + 1}
          </Typography>

          <Slider
            size="small"
            value={currentPage}
            min={0}
            max={totPages}
            onChange={handleSliderChange}
            aria-label="Pagine Catalogo"
            valueLabelDisplay="auto"
            valueLabelFormat={(x) => x + 1} // Mostra numero pagina umano (parte da 1)
            sx={{
              color: 'primary.main', // O un colore specifico es: '#333'
            }}
          />

          <Typography variant="caption" sx={{ color: '#999', mt: 1 }}>
            Usa lo slider o le frecce della tastiera per navigare
          </Typography>
        </Box>

      </div>
    </div>
  );
};

ShopProductsFlip.propTypes = {
  layout: PropTypes.string,
  catalogo: PropTypes.array,
};

export default ShopProductsFlip;